
import './App.css';
import About from './Components/About';
import Footer from './Components/Footer';
// import SlidingImageHeader from './Components/SlidingImageHeader';
import ImageSlider from './Components/ImageSlider';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ContactForm from './Components/ContactForm';
import Top_Header from './Components/Top_Header';
import Imageslide from './Components/Imageslide'
import ProductCard from './Components/ProductCard';
import HomeProductBar from './Components/HomeProductBar';
import Popular_Brands from './Components/Popular_Brands';
import About_p from './Components/About_p';
import Homepage_Poster from './Components/Homepage_Poster';
import Home_page_option from './Components/Home_page_option';
import Home_page_prdoct1 from './Components/Home_page_prdoct1';
import Home_page_product2 from './Components/Home_page_product2';
import Checkout from './Components/Checkout';
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Switch, Route, useNavigate, useLocation } from 'react-router-dom';
import { useRef } from "react";
//import NavBar from "./NavBar";
import PaymentReturnPolicies from './Components/PaymentReturnPolicies';
import Category from './Components/Category';
import Home_page_product3_single_item from './Components/Home_page_product3_single_item';
import Product_list from './Components/Product_list';
import Header from './Components/Header';
import Login_Signup from './Components/Login_Signup';
import Cart from './Components/Cart'
import Stores from './Components/Stores';

import TermsAndConditions from './Components/TermsAndConditions';
import CareerForm from './Components/CareerForm';
import PrivacyPolicy from './Components/PrivacyPolicy';
import ShippingOptions from './Components/ShippingOptions';
import BrandProducts from './Components/BrandProducts';
import Home_page_product3 from './Components/Home_page_product3';
import Home_page_product4 from './Components/Home_page_product4';
import StickyComponent from './Components/Sticky_component';
import Home_page_product5 from './Components/Home_page_product5';
import No_cost_emi_offer from './Components/No_cost_emi_offer';
import Home_page_product6 from './Components/Home_page_product6';
import VideoComponent from './Components/Video-component';
function App() {
  const companies = ['Apple', 'Vivo', 'Samsung', 'HP', 'Bosch', 'LG', 'Sony', 'Daikin', 'Hitachi', 'Haier', 'Carrier'];

  const product1 = [{ id: 1, title: 'Bajaj TMH50 50L Tower Air Cooler with DuraMarine Pump (2-Yr Warranty by Bajaj)', image: '61Lz9abpZJL._SL1500_-300x300.jpg', price: '₹7,999.00', off: '27', Original_price: '₹10,990.00', category: 'AIR COOLER' }, { title: 'Bajaj TMH50 50L Tower Air Cooler with DuraMarine Pump (2-Yr Warranty by Bajaj)', image: '61Lz9abpZJL._SL1500_-300x300.jpg', price: '₹7,999.00', off: '27', Original_price: '₹10,990.00', category: 'AIR COOLER' }, { title: 'Bajaj TMH50 50L Tower Air Cooler with DuraMarine Pump (2-Yr Warranty by Bajaj)', image: '61Lz9abpZJL._SL1500_-300x300.jpg', price: '₹7,999.00', off: '27', Original_price: '₹10,990.00', category: 'AIR COOLER' }, { title: 'Bajaj TMH50 50L Tower Air Cooler with DuraMarine Pump (2-Yr Warranty by Bajaj)', image: '61Lz9abpZJL._SL1500_-300x300.jpg', price: '₹7,999.00', off: '27', Original_price: '₹10,990.00', category: 'AIR COOLER' }]
  const product2 = [{ title: 'Godrej 1.5 Ton 3 Star, Anti-Leak, 5-In-1 Convertible Cooling, Inverter', image: 'SIC-18DTC3-GWA-INDOOR-300x300.png', price: '₹35,590.00', off: '27', Original_price: '₹48,000.00', category: 'AIR CONDITIONER' }, { title: 'Godrej 1.5 Ton 3 Star, Anti-Leak, 5-In-1 Convertible Cooling, Inverter', image: 'SIC-18DTC3-GWA-INDOOR-300x300.png', price: '₹35,590.00', off: '27', Original_price: '₹48,000.00', category: 'AIR CONDITIONER' }, { title: 'Godrej 1.5 Ton 3 Star, Anti-Leak, 5-In-1 Convertible Cooling, Inverter', image: 'SIC-18DTC3-GWA-INDOOR-300x300.png', price: '₹35,590.00', off: '27', Original_price: '₹48,000.00', category: 'AIR CONDITIONER' }, { title: 'Godrej 1.5 Ton 3 Star, Anti-Leak, 5-In-1 Convertible Cooling, Inverter', image: 'SIC-18DTC3-GWA-INDOOR-300x300.png', price: '₹35,590.00', off: '27', Original_price: '₹48,000.00', category: 'AIR CONDITIONER' }]
  const product3 = [{ title: 'vivo V30 5G (8GB RAM, 128GB, Peacock Green)', image: 'VIVO-MOBILE-V30-PEACOCK-GREEN-8GB128GB-300x300.png', price: '₹33,999.00', off: '13', Original_price: '₹38,999.00', category: 'Audio' }, { title: 'vivo V30 5G (8GB RAM, 128GB, Peacock Green)', image: 'VIVO-MOBILE-V30-PEACOCK-GREEN-8GB128GB-300x300.png', price: '₹33,999.00', off: '13', Original_price: '₹38,999.00', category: 'audio' }, { title: 'vivo V30 5G (8GB RAM, 128GB, Peacock Green)', image: 'VIVO-MOBILE-V30-PEACOCK-GREEN-8GB128GB-300x300.png', price: '₹33,999.00', off: '13', Original_price: '₹38,999.00', category: 'audio' }, { title: 'vivo V30 5G (8GB RAM, 128GB, Peacock Green)', image: 'VIVO-MOBILE-V30-PEACOCK-GREEN-8GB128GB-300x300.png', price: '₹33,999.00', off: '13', Original_price: '₹38,999.00', category: 'audio' }]
  const product4 = [{ title: 'Whirlpool 200 L Direct Cool Single Door 3 Star Refrigerator ', image: '215-IMPRO-PRM-3S-COOL-ILLUSIA-Z-300x300.png', price: '₹15,099.00', off: '20', Original_price: '₹18,850.00', category: 'REFRIGERATOR' }, { title: 'Whirlpool 200 L Direct Cool Single Door 3 Star Refrigerator ', image: '215-IMPRO-PRM-3S-COOL-ILLUSIA-Z-300x300.png', price: '₹15,099.00', off: '20', Original_price: '₹18,850.00', category: 'REFRIGERATOR' }, { title: 'Whirlpool 200 L Direct Cool Single Door 3 Star Refrigerator ', image: '215-IMPRO-PRM-3S-COOL-ILLUSIA-Z-300x300.png', price: '₹15,099.00', off: '20', Original_price: '₹18,850.00', category: 'REFRIGERATOR' }, { title: 'Whirlpool 200 L Direct Cool Single Door 3 Star Refrigerator ', image: '215-IMPRO-PRM-3S-COOL-ILLUSIA-Z-300x300.png', price: '₹15,099.00', off: '20', Original_price: '₹18,850.00', category: 'REFRIGERATOR' }]
  const product5 = [{ title: 'Sony Bravia 80 cm (32 inches) HD Ready Smart LED Google TV  ', image: '71sD5XaN61L._SL1500_-1-300x300.jpg', price: '₹26,990.00', off: '23', Original_price: '₹34,900.00', category: 'TV & HOME ENTERTAINMENT' }, { title: 'Sony Bravia 80 cm (32 inches) HD Ready Smart LED Google TV  ', image: '71sD5XaN61L._SL1500_-1-300x300.jpg', price: '₹26,990.00', off: '23', Original_price: '₹34,900.00', category: 'TV & HOME ENTERTAINMENT' }, { title: 'Sony Bravia 80 cm (32 inches) HD Ready Smart LED Google TV  ', image: '71sD5XaN61L._SL1500_-1-300x300.jpg', price: '₹26,990.00', off: '23', Original_price: '₹34,900.00', category: 'TV & HOME ENTERTAINMENT' }, { title: 'Sony Bravia 80 cm (32 inches) HD Ready Smart LED Google TV  ', image: '71sD5XaN61L._SL1500_-1-300x300.jpg', price: '₹26,990.00', off: '23', Original_price: '₹34,900.00', category: 'TV & HOME ENTERTAINMENT' }]
  const poster1 = [{ src: './WEB-BANNER-1600416-1-2048x532.png', title: 'LG TV', width: '620' }, { src: './WEB-BANNER-1600416-2-2048x532.png', title: 'TV', width: '630' }]
  const poster2 = [{ src: './3rd-Banner-1065456-3.png', title: 'c', width: '300' }, { src: './3rd-Banner-1065456-3.png', title: 'c', width: '300' },
    // { src: './3rd-Banner-1065456-3.png', title: 'c', width: '300' }
  ]
  const poster3 = [{ src: './BANNER-4-ALL-1380304-2048x451.png' }, { src: './buy-bosch-product-only-on-khosla-electronics.jpg' }]
  const categories = [
    'Mobile & Tab',
    'Digital Game & Accessories',
    'Computer & Laptop',
    'Cameras & Accessories',
    'TV Entertainment',
    'Audio',
    // Add more categories as needed
  ];

  const navigate = useNavigate();
  useEffect(() => {
    if (!localStorage.getItem('cart')) {
      localStorage.setItem('cart', JSON.stringify([]));
    }
  }, []);

  const location = useLocation(); // Detects route change

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on route change
  }, [location.pathname]);

  return (
    <div className="App">
      {/* <BrandProducts></BrandProducts> */}
      {/* <PaymentReturnPolicies></PaymentReturnPolicies> */}
      {/* <ShippingOptions></ShippingOptions>
 <PrivacyPolicy></PrivacyPolicy> */}
      {/* <div className="container">
      <div className="row">
        <div className="col-3">
          <Category categories={categories} />
        </div>
        <div className="col-9">
          <h5>Welcome to the Electronics Store</h5>
          <p>Select a category to view products.</p>
        </div>
      </div>
    </div> */}
      {/* <Checkout></Checkout> */}
      <Top_Header />
      <Header />
      {/* <NavBar></NavBar> */}
      {/* <Product_list></Product_list> */}
      {/* <Login_Signup></Login_Signup> */}
      <ImageSlider></ImageSlider>
      <Imageslide></Imageslide>
      <Home_page_option companies={companies} />
      {/* <Homepage_Poster images={poster1} /> */}
      <Homepage_Poster images={['https://khoslaslider.s3.ap-south-1.amazonaws.com/BANNER 1 1600416(1).png','https://khoslaslider.s3.ap-south-1.amazonaws.com/BANNER 2 1600416(1).png']} />
      <Home_page_product3 />
      {/* <Homepage_Poster images={poster3} /> */}
      <Homepage_Poster images={['https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2024/05/BANNER-4-ALL-1380304-2048x451.png','https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2023/03/buy-bosch-product-only-on-khosla-electronics.jpg']} />
      <Home_page_product5 />
      <No_cost_emi_offer/>
      <Home_page_product4 category="MOBILE & TAB" />
      <Home_page_product4 category="COMPUTER & LAPTOP" />
      <Home_page_product4 category="AUDIO" />
      <Home_page_prdoct1></Home_page_prdoct1>
      {/* <Home_page_product4 category="WATER HEATER AND GEYSER" /> */}
      <Home_page_product4 category="AIR CONDITIONER" />
      <Home_page_product4 category="REFRIGERATOR " />
      <Home_page_product2></Home_page_product2>
      <Home_page_product4 category="TV & HOME ENTERTAINMENT" />
      <Home_page_product4 category="WASHING MACHINE" />
      <Home_page_product4 category="MICROWAVE OVENS" />

      <VideoComponent/>

      <Home_page_product4 category="KITCHEN CHIMNEY" />
      <Home_page_product6/>
      <Home_page_product4 category="MIXER GRINDER" />

      {/* <HomeProductBar products={product1}/>
   <HomeProductBar products={product2}/>
   <HomeProductBar products={product3}/>
   <HomeProductBar products={product4}/>
   <HomeProductBar products={product5}/> */}

      <Popular_Brands></Popular_Brands>

      {/* <ContactForm></ContactForm> */}
      <img src='https://khoslaslider.s3.ap-south-1.amazonaws.com/image/Kosla-Mascot.png' className='khosla_da_img' onClick={() => window.open(
        'https://api.whatsapp.com/send/?phone=919674425425&text&type=phone_number&app_absent=0',
        '_blank'
      )} />

      <About_p></About_p>
      <Footer></Footer>
      <StickyComponent />
    </div>
  );
}

export default App;
